// import axios from "axios";
// import React, { useState, useEffect } from "react";
// import { Container, Col, Row } from "react-bootstrap";
// import Sidebar from "../Sidebar";
// import { ToastContainer } from "react-toastify";
// import { SERVER_PATH } from "../../config/env";
// import { errorToaster, successToaster } from "../../utils";
// import { useNavigate, useParams } from "react-router-dom";
// import { Breadcrumbs } from "../Breadcrumb";
// import TooltipMessage from "./../Tooltip/index";

// export const UpdateProduct = () => {
//   let nav = useNavigate();
//   let { productId = "" } = useParams();

//   const [message, setMessage] = useState({
//     msg1: true,
//     msg2: true,
//     msg3: true,
//     msg4: true,
//   });

//   let initForm = {
//     product_name: "",
//     description: "",
//     instructions: "",
//     ingredients: "",
//     keywords: "",
//     price: "",
//     offer: "",
//     offer_price: "",
//     category: "",
//     status: "",
//     weight: "",
//     img1: "",
//     img2: "",
//     img3: "",
//     img4: "",
//   };

//   const [data, setData] = useState(initForm);

//   const dataHandler = async (e) => {
//     const arr = { ...data };

//     if (e.target?.files?.length) {
//       let fileSize = Math.round(e.target.files[0].size / 1024);
//       if (fileSize > 0) {
//         if (fileSize <= 5 * 200) {
//           const base64 = await convertToBase64(e.target.files[0]);
//           arr[e.target.name] = base64;
//           setMessage(false);
//         } else {
//           setMessage(true);
//         }
//       }
//     } else {
//       arr[e.target.name] = e.target.value;
//     }
//     console.log(arr);
//     setData(arr);
//   };

//   const convertToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const fileReader = new FileReader();
//       fileReader.readAsDataURL(file);
//       fileReader.onload = () => {
//         resolve(fileReader.result);
//       };
//       fileReader.onerror = (error) => {
//         reject(error);
//       };
//     });
//   };

//   const fetchProductData = () => {
//     axios
//       .post(`${SERVER_PATH}get/product.php`, {
//         product_id: productId,
//       })
//       .then((res) => {
//         setData(res.data[0]);
//       });
//   };

//   const dataSubmit = (e) => {
//     e.preventDefault();

//     let info = { ...data };
//     console.log(info);
//     axios
//       .post(`${SERVER_PATH}put/product.php`, {
//         ...info,
//       })
//       .then(() => {
//         setData(initForm);
//         successToaster({ msg: "Product updated successfully" });
//       })
//       .catch(() => {
//         errorToaster({ msg: "Something went wrong" });
//       });
//   };

//   useEffect(() => {
//     fetchProductData();
//   }, []);

//   return (
//     <>
//       <Container fluid>
//         <Row>
//           <Sidebar />
//           <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
//             <Row className="p-4">
//               <Col className="addProduct rounded shadow p-3">
//                 <Breadcrumbs currentPathName="Update Product" />
//                 <form onSubmit={dataSubmit}>
//                   <div>
//                     <div className="newProductHeadingStyle text-uppercase">
//                       <h1>Update Product</h1>
//                     </div>
//                     <Row>
//                     <div className="addProductField">
//                           <span>Product Id</span>
//                           <input
//                             placeholder="Product Name"
//                             autoComplete="off"
//                             required
//                             type="text"
//                             name="product_name"
//                             value={data.product_id}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                       <Col lg={6} className="addProductDiv">
//                         <div className="addProductField">
//                           <span>name</span>
//                           <input
//                             placeholder="Product Name"
//                             autoComplete="off"
//                             required
//                             type="text"
//                             name="product_name"
//                             value={data.product_name}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>

//                         <div className="addProductField">
//                           <span>price</span>
//                           <input
//                             placeholder="Product Price"
//                             autoComplete="off"
//                             required
//                             type="number"
//                             name="price"
//                             value={data.price > 0 && data.price}
//                             onChange={(e) => {
//                               dataHandler(e);
//                             }}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>description</span>
//                           <textarea
//                             placeholder="Product Description"
//                             autoComplete="off"
//                             required
//                             cols="30"
//                             rows="1"
//                             name="description"
//                             value={data.description}
//                             onChange={(e) => dataHandler(e)}></textarea>
//                         </div>
//                         <div className="addProductField">
//                           <span>weight</span>
//                           <input
//                             placeholder="Product Weight in Gms."
//                             autoComplete="off"
//                             required
//                             type="number"
//                             name="weight"
//                             value={data.weight > 0 && data.weight}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>instructions</span>
//                           <input
//                             placeholder="Product Instructions"
//                             autoComplete="off"
//                             required
//                             type="text"
//                             name="instructions"
//                             value={data.instructions}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>ingrediants</span>
//                           <input
//                             placeholder="Product Ingredients"
//                             type="text"
//                             name="ingredients"
//                             value={data.ingredients}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>keywords</span>
//                           <input
//                             placeholder="Product Keywords"
//                             autoComplete="off"
//                             required
//                             type="text"
//                             name="keywords"
//                             value={data.keywords}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>offer(%)</span>
//                           <input
//                             placeholder="Enter Offer Percentage"
//                             autoComplete="off"
//                             required
//                             type="number"
//                             name="offer"
//                             value={data.offer}
//                             onChange={(e) => dataHandler(e)}
//                           />
//                         </div>
//                         <div className="addProductField">
//                           <span>offer price</span>
//                           <input
//                             readOnly
//                             style={{ cursor: "not-allowed" }}
//                             required
//                             placeholder="Offer Price"
//                             autoComplete="off"
//                             type="number"
//                             name="offer_price"
//                             value={parseInt(
//                               (data.offer_price =
//                                 data.price - (data.price * data.offer) / 100)
//                             )}
//                             onChange={(e) => {
//                               setData({
//                                 ...data,
//                                 offer_price: parseInt(
//                                   (data.offer_price =
//                                     data.price -
//                                     (data.price * data.offer) / 100)
//                                 ),
//                               });
//                               dataHandler(e);
//                             }}
//                           />
//                         </div>
//                       </Col>
//                       <Col lg={6} className="addProductDiv">
//                         <div className="addProductField">
//                           <span>category</span>
//                           <select
//                             autoComplete="off"
//                             required
//                             name="category"
//                             value={data.category}
//                             onChange={(e) => dataHandler(e)}>
//                             <option value="select">Select Category</option>
//                             <option value="herbal">Herbal Product</option>
//                             <option value="garden">Garden Product</option>
//                             <option value="yoga">Yoga Product</option>
//                             <option value="spices">Spices</option>
//                             <option value="food">Food Product</option>
//                           </select>
//                         </div>
//                         <div className="addProductField">
//                           <span>status</span>
//                           <select
//                             name="status"
//                             value={data.status}
//                             onChange={(e) => dataHandler(e)}>
//                             <option value="1">Yes</option>
//                             <option value="0">No</option>
//                           </select>
//                         </div>
//                         <div className="addProductField">
//                           <span>
//                             main image
//                             <small>
//                               <TooltipMessage />
//                             </small>
//                           </span>
//                           <input
//                             autoComplete="off"
//                             required
//                             type="file"
//                             name="img1"
//                             onChange={(e) => {
//                               dataHandler(e, "msg1");
//                             }}
//                           />
//                           {message.msg1 && (
//                             <span className="ms-1 mt-1 text-danger text-capitalize">
//                               upload file size less then 50KB
//                             </span>
//                           )}
//                         </div>
//                         <div className="addProductField">
//                           <span>
//                             sub image one
//                             <small>
//                               <TooltipMessage />
//                             </small>
//                           </span>
//                           <input
//                             autoComplete="off"
//                             required
//                             type="file"
//                             name="img2"
//                             onChange={(e) => {
//                               dataHandler(e, "msg2");
//                             }}
//                           />
//                           {message.msg2 && (
//                             <span className="ms-1 mt-1 text-danger text-capitalize">
//                               upload file size less then 50KB
//                             </span>
//                           )}
//                         </div>
//                         <div className="addProductField">
//                           <span>
//                             sub image two
//                             <small>
//                               <TooltipMessage />
//                             </small>
//                           </span>
//                           <input
//                             autoComplete="off"
//                             required
//                             type="file"
//                             name="img3"
//                             onChange={(e) => dataHandler(e, "msg3")}
//                           />
//                           {message.msg3 && (
//                             <span className="ms-1 mt-1 text-danger text-capitalize">
//                               upload file size less then 50KB
//                             </span>
//                           )}
//                         </div>
//                         <div className="addProductField">
//                           <span>
//                             sub image three
//                             <small>
//                               <TooltipMessage />
//                             </small>
//                           </span>
//                           <input
//                             autoComplete="off"
//                             required
//                             type="file"
//                             name="img4"
//                             onChange={(e) => {
//                               dataHandler(e, "msg3");
//                             }}
//                           />
//                           {message.msg4 && (
//                             <span className="ms-1 mt-1 text-danger text-capitalize">
//                               upload file size less then 50KB
//                             </span>
//                           )}
//                         </div>
//                         <div className="addProductField">
//                           <button className="btn btn-success">
//                             update product
//                           </button>
//                         </div>
//                       </Col>
//                     </Row>
//                   </div>
//                 </form>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//       </Container>
//       <ToastContainer />
//     </>
//   );
// };


import React, { useState, useEffect, useRef } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Sidebar from "../Sidebar";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { errorToaster, successToaster } from "../../utils";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../Breadcrumb";
import apiClient from "../../utils/api";

export const UpdateProduct = () => {
  let nav = useNavigate();
  let { productId = "" } = useParams();

  let initForm = {
    product_id: "",
    product_name: "",
    description: "",
    price: "",
    category: "",
    status: "",
    weight: "",
    height:"",
    img1: "",
    img2: "",
    img3: "",
    img4: "",
  };

  const [data, setData] = useState(initForm);
  const [originalData, setOriginalData] = useState(initForm); // Stores original data for comparison
  const fileInputRefs = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null),
  };

  const triggerFileInput = (field) => {
    fileInputRefs[field].current.click();
  };

  const dataHandler = async (e) => {
    const { name, value, files } = e.target;
    let newData = { ...data };

    if (files?.length) {
      let fileSize = Math.round(files[0].size / 1024);
      if (fileSize > 0 && fileSize <= 50) { // File size limit 50KB
        const base64 = await convertToBase64(files[0]);
        newData[name] = base64;
      } else {
        errorToaster({ msg: "File size must be less than 50KB" });
      }
    } else {
      newData[name] = value;
    }

    setData(newData);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        const result = fileReader.result; // "data:image/jpeg;base64,..."
        const base64 = result.split(",")[1]; // remove "data:image/jpeg;base64,"
        resolve(base64); // send only base64 to backend
      };
      fileReader.onerror = (error) => reject(error);
    });
  };

  const fetchProductData = () => {
  apiClient
      .post(`get/product.php`, { product_id: productId })
      .then((res) => {
        setData(res.data[0]);
        setOriginalData(res.data[0]); // Store original data for comparison
      })
      .catch(() => {
        errorToaster({ msg: "Error fetching product data" });
      });
  };

  const dataSubmit = (e) => {
    e.preventDefault();

    // Create an object with only changed fields
    let updatedFields = {};
    Object.keys(data).forEach((key) => {
      if (data[key] !== originalData[key]) {
        updatedFields[key] = data[key];
      }
    });

    if (Object.keys(updatedFields).length === 0) {
      errorToaster({ msg: "No changes detected!" });
      return;
    }

    updatedFields.product_id = productId; // Always send product_id

    apiClient
      .post(`put/product.php`, updatedFields)
      .then(() => {
        successToaster({ msg: "Product updated successfully" });
        // nav("/products");
      })
      .catch(() => {
        errorToaster({ msg: "Something went wrong" });
      });
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-4">
              <Col className="addProduct rounded shadow p-3">
                <Breadcrumbs currentPathName="Update Product" />
                <form onSubmit={dataSubmit}>
                  <div className="newProductHeadingStyle text-uppercase">
                    <h1>Update Product</h1>
                  </div>
                  <Row>
                    <Col lg={6} className="addProductDiv">
                      <div className="addProductField">
                        <span>Product ID</span>
                        <input
                          type="text"
                          name="product_id"
                          value={data.product_id}
                          readOnly
                        />
                      </div>
                      <div className="addProductField">
                        <span>Name</span>
                        <input
                          type="text"
                          name="product_name"
                          value={data.product_name}
                          onChange={dataHandler}
                          required
                        />
                      </div>
                      <div className="addProductField">
                        <span>Price</span>
                        <input
                          type="number"
                          name="price"
                          value={data.price}
                          onChange={dataHandler}
                          required
                        />
                      </div>
                      <div className="addProductField">
                        <span>Description</span>
                        <textarea
                          name="description"
                          value={data.description}
                          onChange={dataHandler}
                          required
                        />
                      </div>
                      <div className="addProductField">
                        <span>Height (cm)</span>
                        <input
                          type="number"
                          name="height"
                          value={data.height}
                          onChange={dataHandler}
                          required
                        />
                      </div>
                      <div className="addProductField">
                        <span>Weight (gms)</span>
                        <input
                          type="number"
                          name="weight"
                          value={data.weight}
                          onChange={dataHandler}
                          required
                        />
                      </div>
                    </Col>
                    <Col lg={6} className="addProductDiv">
                      <div className="addProductField">
                        <span>Category</span>
                        <select
                          name="category"
                          value={data.category}
                          onChange={dataHandler}
                          required
                        >
                          <option value="">Select Category</option>
                          <option value="statue">statue</option>
                          <option value="jewellery">Jewellery</option>
                          <option value="thanjavurart">Thanjavur art</option>
                          {/* <option value="spices">others</option> */}
                          <option value="others">Others</option>
                        </select>
                      </div>
                      <div className="addProductField">
                        <span>Status</span>
                        <select
                          name="status"
                          value={data.status}
                          onChange={dataHandler}
                        >
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>

                      {/* Image Upload Fields (Optional) */}
                      {[1, 2, 3, 4].map((num) => (
                        <div key={num} className="addProductField">
                          <span>Image {num}</span>
                          <input
                            type="file"
                            name={`img${num}`}
                            ref={fileInputRefs[`img${num}`]}
                            onChange={dataHandler}
                            style={{ display: "none" }}
                          />
                          {data[`img${num}`] && (
                            <img
                              src={`data:image/jpeg;base64,${
                                data[`img${num}`]
                              }`}
                              alt={`Preview ${num}`}
                              width="100"
                              height="100"
                              className="rounded border p-1"
                            />
                          )}
                          <button
                            type="button"
                            className="btn btn-secondary ms-2"
                            onClick={() => triggerFileInput(`img${num}`)}
                          >
                            Update Image
                          </button>
                        </div>
                      ))}
                    </Col>
                  </Row>
                  <button type="submit" className="btn btn-primary mt-3">
                    Update Product
                  </button>
                </form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
};

